export const hippsCategories = [
  {
    id: 1,
    question_key: "B0100",
    new_question_key: null,
    HIPPS_categories: "23",
    sub_nursing_categories: "bs&cp",
    category_names: ["slp", "nursing"],
  },
  {
    id: 2,
    question_key: "B0700",
    new_question_key: null,
    HIPPS_categories: "23",
    sub_nursing_categories: "bs&cp",
    category_names: ["slp", "nursing"],
  },
  {
    id: 3,
    question_key: "C0100",
    new_question_key: null,
    HIPPS_categories: "23",
    sub_nursing_categories: "bs&cp",
    category_names: ["slp", "nursing"],
  },
  {
    id: 4,
    question_key: "C0500",
    new_question_key: null,
    HIPPS_categories: "23",
    sub_nursing_categories: "bs&cp",
    category_names: ["slp", "nursing"],
  },
  {
    id: 5,
    question_key: "C0700",
    new_question_key: null,
    HIPPS_categories: "23",
    sub_nursing_categories: "bs&cp",
    category_names: ["slp", "nursing"],
  },
  {
    id: 6,
    question_key: "C1000",
    new_question_key: null,
    HIPPS_categories: "23",
    sub_nursing_categories: "bs&cp",
    category_names: ["slp", "nursing"],
  },
  {
    id: 7,
    question_key: "D0300",
    new_question_key: "D0160",
    HIPPS_categories: "3",
    sub_nursing_categories: "sch,scl,cc",
    category_names: ["nursing"],
  },
  {
    id: 8,
    question_key: "D0600",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "sch,scl,cc",
    category_names: ["nursing"],
  },
  {
    id: 9,
    question_key: "E0100A",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "bs&cp",
    category_names: ["nursing"],
  },
  {
    id: 10,
    question_key: "E0100B",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "bs&cp",
    category_names: ["nursing"],
  },
  {
    id: 11,
    question_key: "E0200A",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "bs&cp",
    category_names: ["nursing"],
  },
  {
    id: 12,
    question_key: "E0200B",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "bs&cp",
    category_names: ["nursing"],
  },
  {
    id: 13,
    question_key: "E0200C",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "bs&cp",
    category_names: ["nursing"],
  },
  {
    id: 14,
    question_key: "E0800",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "bs&cp",
    category_names: ["nursing"],
  },
  {
    id: 15,
    question_key: "E0900",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "bs&cp",
    category_names: ["nursing"],
  },
  {
    id: 16,
    question_key: "GG0130A1",
    new_question_key: null,
    HIPPS_categories: "13",
    sub_nursing_categories: "sch,nursing_function_score(nfs)",
    category_names: ["pt/ot", "nursing"],
  },
  {
    id: 17,
    question_key: "GG0130A5",
    new_question_key: null,
    HIPPS_categories: "13",
    sub_nursing_categories: "sch,nursing_function_score(nfs)",
    category_names: ["pt/ot", "nursing"],
  },
  {
    id: 18,
    question_key: "GG0130B1",
    new_question_key: null,
    HIPPS_categories: "13",
    sub_nursing_categories: "sch,nursing_function_score(nfs)",
    category_names: ["pt/ot", "nursing"],
  },
  {
    id: 19,
    question_key: "GG0130B5",
    new_question_key: null,
    HIPPS_categories: "13",
    sub_nursing_categories: "sch,nursing_function_score(nfs)",
    category_names: ["pt/ot", "nursing"],
  },
  {
    id: 20,
    question_key: "GG0130C1",
    new_question_key: null,
    HIPPS_categories: "13",
    sub_nursing_categories: "sch,nursing_function_score(nfs)",
    category_names: ["pt/ot", "nursing"],
  },
  {
    id: 21,
    question_key: "GG0130C5",
    new_question_key: null,
    HIPPS_categories: "13",
    sub_nursing_categories: "sch,nursing_function_score(nfs)",
    category_names: ["pt/ot", "nursing"],
  },
  {
    id: 22,
    question_key: "GG0170B1",
    new_question_key: null,
    HIPPS_categories: "13",
    sub_nursing_categories: "sch,nursing_function_score(nfs)",
    category_names: ["pt/ot", "nursing"],
  },
  {
    id: 23,
    question_key: "GG0170B5",
    new_question_key: null,
    HIPPS_categories: "13",
    sub_nursing_categories: "sch,nursing_function_score(nfs)",
    category_names: ["pt/ot", "nursing"],
  },
  {
    id: 24,
    question_key: "GG0170C1",
    new_question_key: null,
    HIPPS_categories: "13",
    sub_nursing_categories: "sch,nursing_function_score(nfs)",
    category_names: ["pt/ot", "nursing"],
  },
  {
    id: 25,
    question_key: "GG0170C5",
    new_question_key: null,
    HIPPS_categories: "13",
    sub_nursing_categories: "sch,nursing_function_score(nfs)",
    category_names: ["pt/ot", "nursing"],
  },
  {
    id: 26,
    question_key: "GG0170D1",
    new_question_key: null,
    HIPPS_categories: "13",
    sub_nursing_categories: "sch,nursing_function_score(nfs)",
    category_names: ["pt/ot", "nursing"],
  },
  {
    id: 27,
    question_key: "GG0170D5",
    new_question_key: null,
    HIPPS_categories: "13",
    sub_nursing_categories: "sch,nursing_function_score(nfs)",
    category_names: ["pt/ot", "nursing"],
  },
  {
    id: 28,
    question_key: "GG0170E1",
    new_question_key: null,
    HIPPS_categories: "13",
    sub_nursing_categories: "sch,nursing_function_score(nfs)",
    category_names: ["pt/ot", "nursing"],
  },
  {
    id: 29,
    question_key: "GG0170E5",
    new_question_key: null,
    HIPPS_categories: "13",
    sub_nursing_categories: "sch,nursing_function_score(nfs)",
    category_names: ["pt/ot", "nursing"],
  },
  {
    id: 30,
    question_key: "GG0170F1",
    new_question_key: null,
    HIPPS_categories: "13",
    sub_nursing_categories: "sch,nursing_function_score(nfs)",
    category_names: ["pt/ot", "nursing"],
  },
  {
    id: 31,
    question_key: "GG0170F5",
    new_question_key: null,
    HIPPS_categories: "13",
    sub_nursing_categories: "sch,nursing_function_score(nfs)",
    category_names: ["pt/ot", "nursing"],
  },
  {
    id: 32,
    question_key: "GG0170I1",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 33,
    question_key: "GG0170I5",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 34,
    question_key: "GG0170J1",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 35,
    question_key: "GG0170J5",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 36,
    question_key: "GG0170K1",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 37,
    question_key: "GG0170K5",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 38,
    question_key: "H0100C",
    new_question_key: null,
    HIPPS_categories: "4",
    sub_nursing_categories: "nta",
    category_names: ["nta"],
  },
  {
    id: 39,
    question_key: "H0100D",
    new_question_key: null,
    HIPPS_categories: "4",
    sub_nursing_categories: null,
    category_names: ["nta"],
  },
  {
    id: 40,
    question_key: "H0200C",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: null,
    category_names: ["nursing"],
  },
  {
    id: 41,
    question_key: "H0500",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: null,
    category_names: ["nursing"],
  },
  {
    id: 42,
    question_key: "I0020B",
    new_question_key: null,
    HIPPS_categories: "12",
    sub_nursing_categories: null,
    category_names: ["pt/ot", "slp"],
  },
  {
    id: 43,
    question_key: "I1300",
    new_question_key: null,
    HIPPS_categories: "4",
    sub_nursing_categories: null,
    category_names: ["nta"],
  },
  {
    id: 44,
    question_key: "I1700",
    new_question_key: null,
    HIPPS_categories: "4",
    sub_nursing_categories: null,
    category_names: ["nta"],
  },
  {
    id: 45,
    question_key: "I2000",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "cc",
    category_names: ["nursing"],
  },
  {
    id: 46,
    question_key: "I2100",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: null,
    category_names: ["nursing"],
  },
  {
    id: 47,
    question_key: "I2500",
    new_question_key: null,
    HIPPS_categories: "4",
    sub_nursing_categories: null,
    category_names: ["nta"],
  },
  {
    id: 48,
    question_key: "I2900",
    new_question_key: null,
    HIPPS_categories: "4",
    sub_nursing_categories: null,
    category_names: ["nta"],
  },
  {
    id: 49,
    question_key: "I4300",
    new_question_key: null,
    HIPPS_categories: "2",
    sub_nursing_categories: null,
    category_names: ["slp"],
  },
  {
    id: 50,
    question_key: "I4400",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "scl",
    category_names: ["nursing"],
  },
  {
    id: 51,
    question_key: "I4500",
    new_question_key: null,
    HIPPS_categories: "2",
    sub_nursing_categories: null,
    category_names: ["slp"],
  },
  {
    id: 52,
    question_key: "I4900",
    new_question_key: null,
    HIPPS_categories: "2",
    sub_nursing_categories: null,
    category_names: ["slp"],
  },
  {
    id: 53,
    question_key: "I5100",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: null,
    category_names: ["nursing"],
  },
  {
    id: 54,
    question_key: "I5200",
    new_question_key: null,
    HIPPS_categories: "34",
    sub_nursing_categories: null,
    category_names: ["nursing", "nta"],
  },
  {
    id: 55,
    question_key: "I5300",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: null,
    category_names: ["nursing"],
  },
  {
    id: 56,
    question_key: "I5500",
    new_question_key: null,
    HIPPS_categories: "2",
    sub_nursing_categories: null,
    category_names: ["slp"],
  },
  {
    id: 57,
    question_key: "I5600",
    new_question_key: null,
    HIPPS_categories: "4",
    sub_nursing_categories: null,
    category_names: ["nta"],
  },
  {
    id: 58,
    question_key: "I6200",
    new_question_key: null,
    HIPPS_categories: "4",
    sub_nursing_categories: null,
    category_names: ["nta"],
  },
  {
    id: 59,
    question_key: "I6300",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: null,
    category_names: ["nursing"],
  },
  {
    id: 60,
    question_key: "I8000",
    new_question_key: null,
    HIPPS_categories: "24",
    sub_nursing_categories: null,
    category_names: ["slp", "nta"],
  },
  {
    id: 61,
    question_key: "J1100C",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "sch",
    category_names: ["nursing"],
  },
  {
    id: 62,
    question_key: "J1550A",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "sch",
    category_names: ["nursing"],
  },
  {
    id: 63,
    question_key: "J1550B",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "sch",
    category_names: ["nursing"],
  },
  {
    id: 64,
    question_key: "J2100",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: "cc",
    category_names: ["pt/ot"],
  },
  {
    id: 65,
    question_key: "J2300",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 66,
    question_key: "J2310",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 67,
    question_key: "J2320",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 68,
    question_key: "J2330",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 69,
    question_key: "J2400",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 70,
    question_key: "J2410",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 71,
    question_key: "J2420",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 72,
    question_key: "J2500",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 73,
    question_key: "J2510",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 74,
    question_key: "J2520",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 75,
    question_key: "J2530",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 76,
    question_key: "J2600",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 77,
    question_key: "J2610",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 78,
    question_key: "J2620",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 79,
    question_key: "J2700",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 80,
    question_key: "J2710",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 81,
    question_key: "J2800",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 82,
    question_key: "J2810",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 83,
    question_key: "J2900",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 84,
    question_key: "J2910",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 85,
    question_key: "J2920",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 86,
    question_key: "J2930",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 87,
    question_key: "J2940",
    new_question_key: null,
    HIPPS_categories: "1",
    sub_nursing_categories: null,
    category_names: ["pt/ot"],
  },
  {
    id: 88,
    question_key: "K0100A",
    new_question_key: null,
    HIPPS_categories: "2",
    sub_nursing_categories: null,
    category_names: ["slp"],
  },
  {
    id: 89,
    question_key: "K0100B",
    new_question_key: null,
    HIPPS_categories: "2",
    sub_nursing_categories: null,
    category_names: ["slp"],
  },
  {
    id: 90,
    question_key: "K0100C",
    new_question_key: null,
    HIPPS_categories: "2",
    sub_nursing_categories: null,
    category_names: ["slp"],
  },
  {
    id: 91,
    question_key: "K0100D",
    new_question_key: null,
    HIPPS_categories: "2",
    sub_nursing_categories: null,
    category_names: ["slp"],
  },
  {
    id: 92,
    question_key: "K0300",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "sch",
    category_names: ["nursing"],
  },
  {
    id: 93,
    question_key: "K0510A1",
    new_question_key: "K0520A2",
    HIPPS_categories: "3",
    sub_nursing_categories: "sch",
    category_names: ["nursing"],
  },
  {
    id: 94,
    question_key: "K0510A2",
    new_question_key: "K0520A3",
    HIPPS_categories: "34",
    sub_nursing_categories: "sch,iv",
    category_names: ["nursing", "nta"],
  },
  {
    id: 95,
    question_key: "K0510B1",
    new_question_key: "K0520B2",
    HIPPS_categories: "3",
    sub_nursing_categories: "sch,scl",
    category_names: ["nursing"],
  },
  {
    id: 96,
    question_key: "K0510B2",
    new_question_key: "K0520B3",
    HIPPS_categories: "3",
    sub_nursing_categories: "sch,scl",
    category_names: ["nursing"],
  },
  {
    id: 97,
    question_key: "K0510C2",
    new_question_key: "K0520C3",
    HIPPS_categories: "2",
    sub_nursing_categories: null,
    category_names: ["slp"],
  },
  {
    id: 98,
    question_key: "K0710A2",
    new_question_key: null,
    HIPPS_categories: "4",
    sub_nursing_categories: "iv",
    category_names: ["nta"],
  },
  {
    id: 99,
    question_key: "K0710A3",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "feeding_tube",
    category_names: ["nursing"],
  },
  {
    id: 100,
    question_key: "K0710B2",
    new_question_key: null,
    HIPPS_categories: "4",
    sub_nursing_categories: "iv",
    category_names: ["nta"],
  },
  {
    id: 101,
    question_key: "K0710B3",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "sch,scl",
    category_names: ["nursing"],
  },
  {
    id: 102,
    question_key: "M0300B1",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "scl",
    category_names: ["nursing"],
  },
  {
    id: 103,
    question_key: "M0300C1",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "scl",
    category_names: ["nursing"],
  },
  {
    id: 104,
    question_key: "M0300D1",
    new_question_key: null,
    HIPPS_categories: "34",
    sub_nursing_categories: "scl,nta",
    category_names: ["nursing", "nta"],
  },
  {
    id: 105,
    question_key: "M0300F1",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "scl",
    category_names: ["nursing"],
  },
  {
    id: 106,
    question_key: "M1030",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "scl",
    category_names: ["nursing"],
  },
  {
    id: 107,
    question_key: "M1040A",
    new_question_key: null,
    HIPPS_categories: "34",
    sub_nursing_categories: "scl",
    category_names: ["nursing", "nta"],
  },
  {
    id: 108,
    question_key: "M1040B",
    new_question_key: null,
    HIPPS_categories: "34",
    sub_nursing_categories: "scl",
    category_names: ["nursing", "nta"],
  },
  {
    id: 109,
    question_key: "M1040C",
    new_question_key: null,
    HIPPS_categories: "34",
    sub_nursing_categories: "scl",
    category_names: ["nursing", "nta"],
  },
  {
    id: 110,
    question_key: "M1040D",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "cc",
    category_names: ["nursing"],
  },
  {
    id: 111,
    question_key: "M1040E",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "cc",
    category_names: ["nursing"],
  },
  {
    id: 112,
    question_key: "M1040F",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "cc",
    category_names: ["nursing"],
  },
  {
    id: 113,
    question_key: "M1200A",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "scl",
    category_names: ["nursing"],
  },
  {
    id: 114,
    question_key: "M1200B",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "scl",
    category_names: ["nursing"],
  },
  {
    id: 115,
    question_key: "M1200C",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "scl",
    category_names: ["nursing"],
  },
  {
    id: 116,
    question_key: "M1200D",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "scl",
    category_names: ["nursing"],
  },
  {
    id: 117,
    question_key: "M1200E",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "scl",
    category_names: ["nursing"],
  },
  {
    id: 118,
    question_key: "M1200F",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "scl,cc",
    category_names: ["nursing"],
  },
  {
    id: 119,
    question_key: "M1200G",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "scl,cc",
    category_names: ["nursing"],
  },
  {
    id: 120,
    question_key: "M1200H",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "scl,cc",
    category_names: ["nursing"],
  },
  {
    id: 121,
    question_key: "M1200I",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "scl",
    category_names: ["nursing"],
  },
  {
    id: 122,
    question_key: "N0350A",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "scl",
    category_names: ["nursing"],
  },
  {
    id: 123,
    question_key: "N0350B",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "scl",
    category_names: ["nursing"],
  },
  {
    id: 124,
    question_key: "O0100A2",
    new_question_key: "O0110A1B",
    HIPPS_categories: "3",
    sub_nursing_categories: "cc",
    category_names: ["nursing"],
  },
  {
    id: 125,
    question_key: "O0100B2",
    new_question_key: "O0110B1B",
    HIPPS_categories: "34",
    sub_nursing_categories: "scl",
    category_names: ["nursing", "nta"],
  },
  {
    id: 126,
    question_key: "O0100C2",
    new_question_key: "O0110C1B",
    HIPPS_categories: "3",
    sub_nursing_categories: "scl,cc",
    category_names: ["nursing"],
  },
  {
    id: 127,
    question_key: "O0100D2",
    new_question_key: "O0110D1B",
    HIPPS_categories: "4",
    sub_nursing_categories: null,
    category_names: ["nta"],
  },
  {
    id: 128,
    question_key: "O0100E2",
    new_question_key: "O0110E1B",
    HIPPS_categories: "234",
    sub_nursing_categories: "es",
    category_names: ["slp", "nursing", "nta"],
  },
  {
    id: 129,
    question_key: "O0100F2",
    new_question_key: "O0110F1B",
    HIPPS_categories: "234",
    sub_nursing_categories: "es",
    category_names: ["slp", "nursing", "nta"],
  },
  {
    id: 130,
    question_key: "O0100H2",
    new_question_key: "O0110H1B",
    HIPPS_categories: "34",
    sub_nursing_categories: "cc",
    category_names: ["nursing", "nta"],
  },
  {
    id: 131,
    question_key: "O0100I2",
    new_question_key: "O0110I1B",
    HIPPS_categories: "34",
    sub_nursing_categories: "cc",
    category_names: ["nursing", "nta"],
  },
  {
    id: 132,
    question_key: "O0100J2",
    new_question_key: "O0110J1B",
    HIPPS_categories: "3",
    sub_nursing_categories: "scl",
    category_names: ["nursing"],
  },
  {
    id: 133,
    question_key: "O0100M2",
    new_question_key: "O0110M1B",
    HIPPS_categories: "34",
    sub_nursing_categories: "es",
    category_names: ["nursing", "nta"],
  },
  {
    id: 134,
    question_key: "O0400D2",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "sch",
    category_names: ["nursing"],
  },
  {
    id: 135,
    question_key: "O0500A",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "bs&cp,rpf",
    category_names: ["nursing"],
  },
  {
    id: 136,
    question_key: "O0500B",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "bs&cp,rpf",
    category_names: ["nursing"],
  },
  {
    id: 137,
    question_key: "O0500C",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: '"bs&cp, rpf"',
    category_names: ["nursing"],
  },
  {
    id: 138,
    question_key: "O0500D",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "bs&cp,rpf",
    category_names: ["nursing"],
  },
  {
    id: 139,
    question_key: "O0500E",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "bs&cp,rpf",
    category_names: ["nursing"],
  },
  {
    id: 140,
    question_key: "O0500F",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "bs&cp,rpf",
    category_names: ["nursing"],
  },
  {
    id: 141,
    question_key: "O0500G",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "bs&cp,rpf",
    category_names: ["nursing"],
  },
  {
    id: 142,
    question_key: "O0500H",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "bs&cp,rpf",
    category_names: ["nursing"],
  },
  {
    id: 143,
    question_key: "O0500I",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "bs&cp,rpf",
    category_names: ["nursing"],
  },
  {
    id: 144,
    question_key: "O0500J",
    new_question_key: null,
    HIPPS_categories: "3",
    sub_nursing_categories: "bs&cp,rpf",
    category_names: ["nursing"],
  },
];
